import { isRequiredText, moreThan, strMax } from './utils';
export const validateReplyContent = [
    isRequiredText('返信内容を入力してください'),
    strMax(1000, '返信内容は1000文字以内で入力してください'),
];
export const validateStaffMessage = [
    isRequiredText('メッセージを入力してください'),
    strMax(1000, 'メッセージは1000文字以内で入力してください'),
];
export const validateReason = [
    isRequiredText('変更理由を記入してください'),
    strMax(255, '255文字以内で入力してください'),
];
export const validateContractStart = [
    isRequiredText('契約開始日を記入してください'),
];
export const validateContractEnd = [
    isRequiredText('契約終了日を記入してください'),
    moreThan('contractStartDate', '契約終了日は契約開始日以降を選択してください'),
];
export const validateRate = [isRequiredText('評価を入力してください')];
